import axios from 'axios';

const API_URL = 'https://chain3-ai-server.onrender.com/api/auth'; // Replace with your backend API URL

// Register a new user
export const register = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/signup`, {
      email,
      password
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'An error occurred during registration' };
  }
};

// Login a user
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, {
      email,
      password
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Invalid email or password' };
  }
};

// Request an invite code
export const requestInvite = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/request-invite`, {
      email
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'An error occurred when requesting an invite' };
  }
};

// Get current user with token
export const getCurrentUser = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to get user information' };
  }
};

// Verify an invite code
export const verifyInviteCode = async (inviteCode) => {
  try {
    const response = await axios.post(`${API_URL}/verify-invite`, {
      inviteCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Invalid invite code' };
  }
};
